import { QueryClient } from '@tanstack/react-query';

export const disableAllRefetch = {
  refetchInterval: false,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
} as const;

const QueryClientDefaultOptions = {
  queries: {
    ...disableAllRefetch,
    retry: 3,
  },
};

export const appQueryClient = new QueryClient({
  defaultOptions: QueryClientDefaultOptions,
});
